import { BasePortal, MainLoading, RouterGuard } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import CurriculumPlanning from '../pages/CurriculumPlanning';
import SchoolStructureSetup from '../pages/SchoolStructureSetup';
import TeachersManagement from '../pages/TeachersManagement';
import TimetableGenerationManagement from '../pages/TimetableGenerationManagement';
import TimetableRulesPreferences from '../pages/TimetableRulesPreferences';
import UploadDataManagement from '../pages/UploadDataManagement';
import { routes, toRelativePath } from './routes';

export function ZoneRoutes() {
  return (
    <Routes>
      <Route path="*" element={<Navigate to={routes.notFound} />} />
      <Route path={toRelativePath(routes.base)} element={<Navigate to={routes.uploadDataManagement} />} />

      <Route
        element={<BasePortal sidebar microSystem showUserRole miniSidebar={true} navbar={true} sidebarHeader={true} />}
      >
        <Route
          path={toRelativePath(routes.uploadDataManagement)}
          element={
            <Suspense fallback={<MainLoading />}>
              <UploadDataManagement />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.curriculumPlanning)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CurriculumPlanning />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.schoolStructureSetup)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SchoolStructureSetup />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.teachersManagement)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TeachersManagement />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.timetableRulesPreferences)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TimetableRulesPreferences />
            </Suspense>
          }
        />
        <Route
          path={toRelativePath(routes.timetableGenerationManagement)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TimetableGenerationManagement />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
}
